module.exports = __webpack_public_path__ + "img/RenameIcon.badf1fed.png";